import type { SnapshotEventAction } from 'base/global/employee-snapshot/types';
import { validateEmployeeId } from 'base/global/employee-snapshot/validators/validate-employee-id';
import { validateOpen } from 'base/global/employee-snapshot/validators/validate-open';
import { useEffect, useState } from 'react';

import { SnapshotContainer as EmployeeSnapshot } from '@bamboohr/shared-experiences/employee-snapshot/snapshot-container';

import { SNAPSHOT_EVENT_NAME } from './constants';

export function SnapshotContainer() {
	const [snapshotOpen, setSnapshotOpen] = useState(false);
	const [selectedEmployeeId, setSelectedEmployeeId] = useState<string>('');

	function globalSnapshotOpenState(e: CustomEvent<SnapshotEventAction>) {
		const { open, employeeId } = e.detail;
		if (!validateOpen(open) || !validateEmployeeId(employeeId)) {
			console.warn('Received invalid data in employee-dialog event');
			return;
		}
		if (open) {
			setSnapshotOpen(true);
			setSelectedEmployeeId(employeeId as string);
		} else {
			setSnapshotOpen(false);
			setSelectedEmployeeId('');
		}
	}

	useEffect(() => {
		window.addEventListener(SNAPSHOT_EVENT_NAME, globalSnapshotOpenState);

		return () => {
			window.removeEventListener(SNAPSHOT_EVENT_NAME, globalSnapshotOpenState);
		};
	}, []);

	return snapshotOpen ? (
		<EmployeeSnapshot
			employeeId={selectedEmployeeId}
			isOpen={snapshotOpen}
			onClose={() => {
				setSnapshotOpen(false);
			}}
		/>
	) : null;
}
